import { translateDynamicKey, translateWithParams } from '@/types/translation';
import { TFunction } from 'i18next';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ValidationError } from './dateRangeUtils';

export const translateValidationError = (error: ValidationError, t: TFunction): string => {
  if (!error.message) return '';
  if (error.params) {
    return String(translateWithParams(t, error.message, error.params));
  }
  return translateDynamicKey(t, error.message);
};

interface UseDateRangeValidationProps {
  name: string;
  setValidationError: (error: ValidationError) => void;
}

interface UseDateRangeValidationResult {
  applyValidation: (error: ValidationError) => void;
  translateError: (error: ValidationError) => string;
}

export const useDateRangeValidation = ({
  name,
  setValidationError,
}: UseDateRangeValidationProps): UseDateRangeValidationResult => {
  const { t } = useTranslation();
  const { setError, clearErrors } = useFormContext();

  const applyValidation = useCallback(
    (error: ValidationError) => {
      setValidationError(error);
      const message = translateValidationError(error, t);
      if (message) {
        setError(name, { type: 'manual', message });
      } else {
        clearErrors(name);
      }
    },
    [t, name, setError, clearErrors, setValidationError],
  );

  const translateError = useCallback((error: ValidationError) => translateValidationError(error, t), [t]);

  return { applyValidation, translateError };
};
